export const questionnaire = {
	'field_company': 'Company or name of institution',
	'field_sector': 'Sector',
	'field_usage': 'How do you plan to use LightlyOne?',
	'field_usage_other': 'Please specify your motivation',
}
export default questionnaire;